import axios from '@/mod/axiosMod';

export default {
  // https://km.sankuai.com/page/1208864730 文档
  queryPartnerInfo() {
    return axios.get('/apigw/api/kdb/partner-info');
  },
};
